import React from "react";
import { Props } from "./types";
import { useLazyLoad } from "../../helpers/hooks";
const Comp = React.lazy(() => import("./"));

export default (props: Props) => useLazyLoad(<Comp {...props} />);
